import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../../../Atoms';
import { MonthNames } from '../../index.constants';
import { DateRangeContext } from '../../index.context';
import { StyledMonths, StyledMonth } from './index.styles';

export const Months = ({ onSelect, date }) => {
    const { dispatch, state } = useContext(DateRangeContext);

    const stateYear = state[date].getFullYear();

    const isMonthSelected = month => {
        const dFirst = new Date(stateYear, month, 1);
        const dLast = new Date(stateYear, month + 1, 0);
        if (!state.selectedInitialDate || !state.selectedFinalDate) return false;
        return (
            state.selectedInitialDate.toLocaleDateString() === dFirst.toLocaleDateString() &&
            state.selectedFinalDate.toLocaleDateString() === dLast.toLocaleDateString()
        );
    };

    const selectMonth = month => {
        dispatch({ type: onSelect, year: stateYear, month });
    };

    return (
        <StyledMonths>
            {MonthNames.map((month, monthIndex) => (
                <StyledMonth
                    key={month}
                    selected={isMonthSelected(monthIndex)}
                    onClick={() => selectMonth(monthIndex)}
                >
                    <Text>{month}</Text>
                </StyledMonth>
            ))}
        </StyledMonths>
    );
};

Months.propTypes = {
    onSelect: PropTypes.string,
    date: PropTypes.string,
};

/* istanbul ignore next */
Months.defaultProps = {
    onSelect: '',
    date: '',
};
